import { OperationVariables } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

import { Article } from '../../../../types/__codegen__/sanity/graphql';
import { GET_LATEST_BLOG_POSTS, GET_LATEST_BLOG_POSTS_BY_TYPE } from '../../../../cms/queries/blog-queries.gql';
import uniqueContentWithDraftPrecedence from '../../../../cms/utils/unique-content-with-draft-precedence';

type ArticleQueryResult = {
  data: Article[] | null;
  isLoading: boolean;
  error: Error | undefined;
};

type UseGetArticleParams = {
  options: useQuery.Options<any, OperationVariables>;
};

const useGetLatestArticles = ({ options }: UseGetArticleParams): ArticleQueryResult => {
  const { type } = options.variables || {};
  const queryToFetch = type ? GET_LATEST_BLOG_POSTS_BY_TYPE : GET_LATEST_BLOG_POSTS;
  const { data, loading: isLoading, error } = useQuery(queryToFetch, options);
  const articles = uniqueContentWithDraftPrecedence(data?.allArticle);
  return { data: articles, error, isLoading };
};

export default useGetLatestArticles;
